export * from './tick-tock.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/tick-tock/index.ts